var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"mt-4",attrs:{"rules":[_vm.rules.employeeNumberFormat],"label":"社員番号","hint":"0詰めの3桁で入力してください。 1の場合は001。","outlined":"","dense":""},model:{value:(_vm.setEmployeeNumber),callback:function ($$v) {_vm.setEmployeeNumber=$$v},expression:"setEmployeeNumber"}})
}
var staticRenderFns = []

export { render, staticRenderFns }